import angular from 'angular';
import solverProgressComponent from './solver-progress.component';

let solverProgressModule = angular.module('solver-progress', [])

.component('solverProgress', solverProgressComponent)

.name;

export default solverProgressModule;



// WEBPACK FOOTER //
// ./client/app/common/solver-progress/solver-progress.js